import React, { useContext, useEffect, useState } from "react";
import axios, { authIsValid } from "../axios";
import LoginContext from "../context/LoginContext";
import { useCookies } from "react-cookie";
import bannerSrc from "../img/gg-banner-fs.png";
import Glogo from "./Glogo";
import { useNavigate } from "react-router-dom";

function Formula({
  formula,
  multiplier,
  isMyFormula,
  addedToMyFormulas,
  setAddedToMyFormulas,
}) {
  const { isLoggedIn } = useContext(LoginContext);
  const [cookies, setCookies] = useCookies();
  const navigate = useNavigate();
  const [materialModifier, setMaterialModifier] = useState(1);

  const printFormula = () => {
    window.print();
  };

  const getTodaysDate = () => {
    let dateString = "";
    const date = new Date();
    dateString =
      date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    return dateString;
  };

  const handleAddToMyFormulas = async () => {
    try {
      const response = await axios.put(
        "/users/addToMyFormulas",
        { formulaId: formula._id },
        { headers: { "x-access-token": cookies.access_token } }
      );
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        //console.log(response);
        setAddedToMyFormulas(true);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    let totalQty = 0;
    formula?.materials.forEach((material) => {
      totalQty += material.amount;
    });
    //console.log(Number((1000 / (totalQty / 100)).toFixed(4)));
    setMaterialModifier(Number((1000 / (totalQty / 100)).toFixed(4)));
  }, [formula]);

  return (
    <div
      id="formulaContainer"
      className="row"
      style={!isMyFormula ? { marginTop: "40px" } : { marginTop: "0px" }}
    >
      {formula === null || formula === undefined ? (
        <div className="col-md-12 col-sm-12 col-xs-12">
          {!isMyFormula ? (
            <h4>No Results</h4>
          ) : (
            <h5 style={{ textAlign: "center" }}>Select Formula to View</h5>
          )}
        </div>
      ) : (
        <>
          <div className="col-md-7 col-sm-12 col-xs-12 g-0">
            <img
              className="formula-banner-image no-print"
              alt="Green Galaxy Fusion Banner"
              src={bannerSrc}
              style={{
                backgroundColor: formula.color?.hex || "white",
                marginBottom: "15px",
              }}
            />
            <div className="row mixer-formula-info">
              <div className="col-md-6 col-sm-12 col-xs-12 no-print">
                <h4 className="color-ryoGray">Green Galaxy Fusion Formula:</h4>
              </div>
              <div className="col-md-5 col-sm-12 col-xs-12 no-print">
                <h4 className="futuraBold">{formula.color?.name}</h4>
              </div>
            </div>
            <div className="row mixer-formula-info">
              <div className="col-md-6 col-sm-12 col-xs-12 no-print">
                <h5 className="color-ryoGray">{multiplier} grams</h5>
              </div>
              <div className="col-md-4 col-sm-12 col-xs-12 pull-right no-print">
                <h5 className="color-ryoGray">Date: {getTodaysDate()}</h5>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 printable">
              <div className="no-screen">
                <h3>Green Galaxy Fusion</h3>
                <h2>{formula.color?.name}</h2>
                <h4>{multiplier} grams</h4>
                <h4>{getTodaysDate()}</h4>
              </div>
              <img
                className="formula-banner-image no-screen"
                alt="Green Galaxy Fusion Banner"
                src={bannerSrc}
                style={{ backgroundColor: formula.color?.hex || "white" }}
              />
              <table className="table table-bordered table-responsive">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th className="no-print" style={{ textAlign: "center" }}>
                      Color
                    </th>
                    <th>Name</th>
                    <th style={{ textAlign: "right" }}>Amount&nbsp;(g)</th>
                  </tr>
                </thead>
                <tbody>
                  {formula.materials.length > 0 &&
                    formula.materials.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.material.code}</td>
                          <td
                            className="no-print"
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <Glogo
                              hasStroke={true}
                              size="md"
                              color={item.material.hex}
                            />
                            {/*<span
                              className="colorSwatch"
                              style={{
                                backgroundColor: item.material.hex,
                              }}
                            ></span>*/}
                          </td>
                          <td>
                            <a href={item.material.url} target="_blank">
                              {item.material.name}
                            </a>
                          </td>
                          <td align="right">
                            {(
                              (item.amount / 100) *
                              materialModifier *
                              (multiplier / 1000.0)
                            ).toFixed(2)}
                            g
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div
              className="col-12"
              style={{
                display: "flex",
                flexWrap: isMyFormula ? "nowrap" : "wrap",
                justifyContent: "space-between",
              }}
            >
              <div
                className={
                  isMyFormula ? "color-ryoGray" : "col-8 color-ryoGray"
                }
              >
                <h6 className="formulaComments">Comments:</h6>
                <p>{formula.comments}</p>
              </div>
              {!isMyFormula && isLoggedIn && (
                <div className="addToMyFormulas col-4 no-print">
                  <button
                    id="addToMyFormulasBtn"
                    className="btn btn-md futuraBold"
                    type="button"
                    style={{ fontSize: 12 }}
                    onClick={handleAddToMyFormulas}
                  >
                    {addedToMyFormulas ? "Added" : "Add To My Formulas"}
                  </button>
                </div>
              )}
              {!isMyFormula && (
                <div className="col-9 no-print">
                  <p style={{ fontSize: 14 }}>
                    If you feel this formula is incorrect, send us a
                    <a
                      className="btn btn-sm futuraBold"
                      href={`https://3518025.extforms.netsuite.com/app/site/crm/externalcasepage.nl/compid.3518025/.f?formid=53&h=AACffht_NlqQ3WZfbQNFdOGY1wYYEep8xus&title=Fusion%20Pantone%20Formula%20Feedback&custeventcode=${formula.code}`}
                      target="_blank"
                    >
                      <button
                        className="btn btn-sm"
                        style={{
                          color: "#353638",
                          fontSize: 13,
                          textTransform: "uppercase",
                          backgroundColor: "#eaeaea",
                        }}
                      >
                        Correct Formula Request
                      </button>
                    </a>
                  </p>
                </div>
              )}
              <div className="printFormula no-print" style={{ paddingTop: 4 }}>
                <button
                  className="btn btn-sm btn-ryoForest futuraBold"
                  onClick={printFormula}
                >
                  Print Formula
                </button>
              </div>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-12 col-xs-12 no-print"
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Glogo hasStroke={false} color={formula.color?.hex} />
            <p className="disclaimer no-print">
              Color may differ slightly from how it appears on your screen due
              to varying monitor settings
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default Formula; //comments, correct pantone
